import { cn } from "@cieda/djayma-ui";
import { Button } from "@cieda/djayma-ui";
import { X } from "lucide-react";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface BulkAction {
  readonly label: string;
  readonly onClick: () => void;
  readonly variant?: "default" | "destructive";
}

export interface BulkActionBarProps {
  readonly selectedCount: number;
  readonly actions: readonly BulkAction[];
  readonly onClear: () => void;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function BulkActionBar({ selectedCount, actions, onClear }: BulkActionBarProps) {
  if (selectedCount <= 0) return null;

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 border-t border-stone-200 bg-white px-4 py-3 shadow-lg",
        "animate-fade-up md:px-6",
      )}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button
            onClick={onClear}
            className="rounded-md p-1 text-stone-400 hover:bg-stone-100 hover:text-stone-600"
            aria-label="Tout désélectionner"
          >
            <X className="h-4 w-4" />
          </button>
          <span className="text-sm font-medium text-stone-700">
            {selectedCount} sélectionné{selectedCount > 1 ? "s" : ""}
          </span>
        </div>

        <div className="flex items-center gap-2">
          {actions.map((action) => (
            <Button
              key={action.label}
              variant={action.variant === "destructive" ? "destructive" : "default"}
              size="sm"
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
